import QueryContainer from 'containers/Query/index'
import React from 'react'

export default function QureyPage() {
  return (
  <QueryContainer/>
  )
}
